import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
  faArrowRight,
  faPen,
} from "@fortawesome/free-solid-svg-icons";

import toast from "react-hot-toast";

import NotificationCampaignForm from "../components/notifications/NotificationCampaignForm";

import {
  notificationCampaignsApi,
} from "../api/notificationCampaignsApi";

import type {
  CreateNotificationCampaignInput,
  NotificationCampaign,
  UpdateNotificationCampaignInput,
} from "../types/notification-campaigns.types";

import "../screenstyles/NotificationCampaignForm.css";

const EditNotificationCampaign:
React.FC = () => {
  const {
    campaignId,
  } =
    useParams<{
      campaignId:
        string;
    }>();

  const navigate =
    useNavigate();

  const [
    campaign,
    setCampaign,
  ] =
    useState<
      NotificationCampaign |
      null
    >(null);

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  const [
    saving,
    setSaving,
  ] =
    useState(false);

  useEffect(() => {
    if (
      !campaignId
    ) {
      navigate(
        "/notification-campaigns",
      );

      return;
    }

    const load =
      async () => {
        try {
          setLoading(
            true,
          );

          const result =
            await notificationCampaignsApi
              .getById(
                campaignId,
              );

          setCampaign(
            result.campaign,
          );
        } catch (
          error: any
        ) {
          console.error(
            "Failed to load campaign:",
            error,
          );

          toast.error(
            error?.message ||
              "فشل تحميل الحملة",
          );

          navigate(
            "/notification-campaigns",
          );
        } finally {
          setLoading(
            false,
          );
        }
      };

    load();
  }, [
    campaignId,
    navigate,
  ]);

  const handleSubmit =
    async (
      input:
        CreateNotificationCampaignInput,
    ) => {
      if (
        !campaignId
      ) {
        return;
      }

      try {
        setSaving(
          true,
        );

        const payload:
          UpdateNotificationCampaignInput =
          {
            ...input,
          };

        const result =
          await notificationCampaignsApi
            .update(
              campaignId,
              payload,
            );

        toast.success(
          "تم تحديث الحملة بنجاح",
        );

        navigate(
          `/notification-campaigns/${result.campaign.campaignId}`,
        );
      } catch (
        error: any
      ) {
        console.error(
          "Failed to update campaign:",
          error,
        );

        toast.error(
          error?.message ||
            "فشل تحديث الحملة",
        );
      } finally {
        setSaving(
          false,
        );
      }
    };

  if (
    loading
  ) {
    return (
      <div className="notification-campaign-form-page">
        <div className="notification-campaign-form-state">
          جاري تحميل الحملة...
        </div>
      </div>
    );
  }

  if (!campaign) {
    return null;
  }

  return (
    <div className="notification-campaign-form-page">
      <header className="notification-campaign-form-header">
        <div>
          <span>
            <FontAwesomeIcon
              icon={faPen}
            />

            تعديل الحملة
          </span>

          <h1>
            {campaign.name}
          </h1>

          <p>
            تعديل محتوى الحملة
            والجمهور المستهدف
            والجدولة.
          </p>
        </div>

        <button
          type="button"
          onClick={() =>
            navigate(
              `/notification-campaigns/${campaignId}`,
            )
          }
        >
          <FontAwesomeIcon
            icon={
              faArrowRight
            }
          />

          رجوع
        </button>
      </header>

      <NotificationCampaignForm
        initialCampaign={
          campaign
        }
        loading={
          saving
        }
        submitLabel="حفظ التعديلات"
        onSubmit={
          handleSubmit
        }
      />
    </div>
  );
};

export default EditNotificationCampaign;